import React, { createContext, useState, useContext, useEffect, useRef } from 'react';

const RadioContext = createContext();

export const RadioProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(0.8);
  const audioRef = useRef(null);

  useEffect(() => {
    // Initialize audio object once
    if (!audioRef.current) {
      audioRef.current = new Audio('https://s101.radiolize.com/radio/8050/radio.mp3');
      audioRef.current.preload = 'none';
      
      // Handle events
      audioRef.current.onplay = () => setIsPlaying(true);
      audioRef.current.onpause = () => setIsPlaying(false);
      audioRef.current.onerror = (e) => {
        console.error("Audio error:", e);
        setIsPlaying(false);
      };
    }

    return () => {
      // Clean up if the entire app unmounts (unlikely in this structure)
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  }, [volume]);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      // Reload src if needed to get to "live" edge or just play
      // For simple streams, play() usually resumes or starts.
      // To ensure we are live, we can re-assign src, but that might cause a delay.
      // Let's stick to simple play first.
      const playPromise = audioRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.error("Playback failed:", error);
          setIsPlaying(false);
        });
      }
    }
  };

  return (
    <RadioContext.Provider value={{ isPlaying, togglePlay, volume, setVolume }}>
      {children}
    </RadioContext.Provider>
  );
};

export const useRadio = () => useContext(RadioContext);